import withAuthenticableNavigationBlock from './with-authenticable-navigation-block-controller'

export default withAuthenticableNavigationBlock
